import { object } from 'valibot';

import { EmailSchema } from './EmailSchema';

export const ForgotPasswordSchema = () =>
  object({
    email: EmailSchema()
  });
